// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Fasthand&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Delicious+Handrawn&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cedarville+Cursive&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker__input-container {
  position: initial !important;
}
.select-none-cls{
  -webkit-user-select: none;
  /* Disable text selection in WebKit browsers */
  user-select: none;
}
.widgets {
  -webkit-user-select: none;
  /* Disable text selection in WebKit browsers */
  user-select: none;
}

.radioButton {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  font-size: 12px;
  border: 1px solid #007bff;
  border-radius: 50px;
}

.signatureCanvas {
  width: 460px;
  height: 184px;
}

.intialSignatureCanvas {
  width: 150px;
  height: 150px;
}

.intialSignature {
  border: 2px solid #888;
  background-color: rgb(255, 255, 255);
  width: 183px;
  height: 183px;
}

.penContainerDefault {
  width: 460px;
}

.icon {
  position: absolute;
  font-size: 14px;
  cursor: pointer;
  z-index: 2;
  background: white;
}

.ScrollbarsCustom-TrackY {
  width: 4px !important;
}
.ScrollbarsCustom-TrackX {
  height: 4px !important;
}

.signYourselfBlock {
  padding: 0px;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.sendMail {
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.1),
    0 1px 2px rgba(0, 0, 0, 0.18);
  padding: 3px 30px;
  color: white;
  font-weight: 500 !important;
  font-size: 14px !important;
  border: none;
  margin-left: 10px;
}

.user {
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.disabled {
  opacity: 0.5;
  /* Example: reduce opacity to visually indicate disabled state */
  pointer-events: none;
  /* Prevents mouse clicks and other events */
  /* background-color: #888; */
}

.signTab {
  cursor: pointer !important;
  font-weight: 400 !important;
  margin: 7px !important;
  font-size: 15px !important;
}

.signerComponent {
  /* box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px; */
  /* width: 180px; */
  background-color: white;
}

.uploadImgLogo {
  font-size: 50px;
}

.DropdownMenuContent,
.DropdownMenuSubContent {
  min-width: 130px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  padding: 5px;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  z-index: 30 !important;
}

.DropdownMenuContent[data-side="top"],
.DropdownMenuSubContent[data-side="top"] {
  animation-name: slideDownAndFade;
}

.DropdownMenuContent[data-side="right"],
.DropdownMenuSubContent[data-side="right"] {
  animation-name: slideLeftAndFade;
}

.DropdownMenuContent[data-side="bottom"],
.DropdownMenuSubContent[data-side="bottom"] {
  animation-name: slideUpAndFade;
}

.DropdownMenuContent[data-side="left"],
.DropdownMenuSubContent[data-side="left"] {
  animation-name: slideRightAndFade;
}

.DropdownMenuItem {
  font-size: 13px;
  line-height: 1;
  color: black;
  background-color: #fff;
  display: flex;
  align-items: center;
  height: 25px;
  padding: 0 5px;
  position: relative;
  padding-left: 20px;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
  border: none;
}

.SelectTrigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 70px;
  font-size: 13px;
  line-height: 1;
  height: 35px;
  gap: 5px;
  border: none;
  background-color: #887abf;
  width: 100px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

.selectEmail {
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 15px;
  font-size: 13px;
  line-height: 1;
  height: 35px;
  gap: 5px;
  border: none;
  background-color: #887abf;
  width: 200px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

option {
  overflow-y: scroll;
}

.SelectTrigger:hover {
  border: none;
  outline: none;
}

.selectEmail:hover {
  border: none;
  outline: none;
}

.SelectTrigger:focus {
  /* box-shadow: 0 0 0 2px black; */
  border: none;
  outline: none;
}

.selectEmail:focus {
  /* box-shadow: 0 0 0 2px black; */
  border: none;
  outline: none;
}

.SelectTrigger[data-placeholder] {
  color: black;
}

.SelectIcon {
  color: Var(--violet-11);
}

.SelectContent {
  overflow: hidden;
  background-color: white;
  border-radius: 6px;
  box-shadow:
    0px 10px 38px -10px rgba(22, 23, 24, 0.35),
    0px 10px 20px -15px rgba(22, 23, 24, 0.2);
}

.SelectViewport {
  padding: 5px;
}

.SelectItem {
  font-size: 13px;
  line-height: 1;
  color: var(--violet-11);
  border-radius: 3px;
  display: flex;
  align-items: center;
  height: 25px;
  padding: 0 35px 0 25px;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  z-index: 10 !important;
}

.SelectItem[data-disabled] {
  color: var(--mauve-8);
  pointer-events: none;
}

.SelectItem[data-highlighted] {
  outline: none;
  background-color: var(--violet-9);
  color: var(--violet-1);
}

.SelectLabel {
  padding: 0 25px;
  font-size: 12px;
  line-height: 25px;
  color: var(--mauve-11);
}

.SelectSeparator {
  height: 1px;
  background-color: var(--violet-6);
  margin: 5px;
}

.SelectItemIndicator {
  position: absolute;
  left: 0;
  width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.SelectScrollButton {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  background-color: white;
  color: var(--violet-11);
  cursor: default;
}

.dropDownStyle {
  width: auto;
}

.autoSignScroll {
  overflow-y: auto;
}

.autoSignScroll::-webkit-scrollbar {
  display: none;
}

.validateInputText {
  width: 76%;
}

.radioGroupInput {
  width: 100%;
}

.radioGroup {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

@media screen and (max-width: 766px) {
  .validateInputText {
    width: 93%;
  }

  .dropdown-menu {
    min-width: 0rem !important;
  }

  #navbar {
    overflow: hidden;
    z-index: 49;
  }

  /* Navbar links */
  #navbar a {
    float: left;
    display: block;
    color: #f2f2f2;
    text-align: center;
    padding: 14px;
    text-decoration: none;
  }

  #navbar a.active {
    background-color: #4caf50;
    color: white;
  }

  /* Page content */
  .content {
    padding: 16px;
  }

  /* The sticky class is added to the navbar
  with JS when it reaches its scroll position */
  .stickyHead {
    top: 50px;
    left: 0.9rem;
  }

  .stickySignerHead {
    position: fixed;
  }

  /* Add some top padding to the page content
  to prevent sudden quick movement (as the
  navigation bar gets a new position at the top of the
  page (position:fixed and top:0) */
  .stickyHead + .content {
    padding-top: 60px;
  }
}

@media screen and (max-width: 487px) and (min-width: 351px) {
  .signatureCanvas {
    width: 300px;
    height: 120px;
  }

  .penContainerDefault {
    width: 300px;
  }

  .uploadImgLogo {
    font-size: 30px;
  }

  .signTab {
    font-weight: 500 !important;
    font-size: 12px !important;
  }
}

.scroll-hide::-webkit-scrollbar {
  display: none;
}
@media screen and (max-width: 350px) and (min-width: 311px) {
  .signatureCanvas {
    width: 280px;
    height: 112px;
  }

  .penContainerDefault {
    width: 280px;
  }

  .signTab {
    font-weight: 500 !important;

    font-size: 10px !important;
  }

  .uploadImgLogo {
    font-size: 25px;
  }
}

@media screen and (max-width: 310px) {
  .signatureCanvas {
    width: 230px;
    height: 92px;
  }

  .penContainerDefault {
    width: 230px;
  }

  .signTab {
    font-weight: 500 !important;
    font-size: 8px !important;
  }

  .uploadImgLogo {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/signature.css"],"names":[],"mappings":"AAKA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,8CAA8C;EAE9C,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,8CAA8C;EAE9C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE;;iCAE+B;EAC/B,iBAAiB;EACjB,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,gEAAgE;EAChE,oBAAoB;EACpB,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,wDAAwD;EACxD,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB;;6CAE2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA,iBAAiB;EACjB;IACE,aAAa;EACf;;EAEA;+CAC6C;EAC7C;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;;mCAGiC;EACjC;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;;IAE3B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Fasthand&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Delicious+Handrawn&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Cedarville+Cursive&display=swap\");\n\n.react-datepicker__input-container {\n  position: initial !important;\n}\n.select-none-cls{\n  -webkit-user-select: none;\n  /* Disable text selection in WebKit browsers */\n  -moz-user-select: none;\n  user-select: none;\n}\n.widgets {\n  -webkit-user-select: none;\n  /* Disable text selection in WebKit browsers */\n  -moz-user-select: none;\n  user-select: none;\n}\n\n.radioButton {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  font-size: 12px;\n  border: 1px solid #007bff;\n  border-radius: 50px;\n}\n\n.signatureCanvas {\n  width: 460px;\n  height: 184px;\n}\n\n.intialSignatureCanvas {\n  width: 150px;\n  height: 150px;\n}\n\n.intialSignature {\n  border: 2px solid #888;\n  background-color: rgb(255, 255, 255);\n  width: 183px;\n  height: 183px;\n}\n\n.penContainerDefault {\n  width: 460px;\n}\n\n.icon {\n  position: absolute;\n  font-size: 14px;\n  cursor: pointer;\n  z-index: 2;\n  background: white;\n}\n\n.ScrollbarsCustom-TrackY {\n  width: 4px !important;\n}\n.ScrollbarsCustom-TrackX {\n  height: 4px !important;\n}\n\n.signYourselfBlock {\n  padding: 0px;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.sendMail {\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.1),\n    0 1px 2px rgba(0, 0, 0, 0.18);\n  padding: 3px 30px;\n  color: white;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  border: none;\n  margin-left: 10px;\n}\n\n.user {\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n.disabled {\n  opacity: 0.5;\n  /* Example: reduce opacity to visually indicate disabled state */\n  pointer-events: none;\n  /* Prevents mouse clicks and other events */\n  /* background-color: #888; */\n}\n\n.signTab {\n  cursor: pointer !important;\n  font-weight: 400 !important;\n  margin: 7px !important;\n  font-size: 15px !important;\n}\n\n.signerComponent {\n  /* box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px; */\n  /* width: 180px; */\n  background-color: white;\n}\n\n.uploadImgLogo {\n  font-size: 50px;\n}\n\n.DropdownMenuContent,\n.DropdownMenuSubContent {\n  min-width: 130px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n  padding: 5px;\n  animation-duration: 400ms;\n  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);\n  will-change: transform, opacity;\n  z-index: 30 !important;\n}\n\n.DropdownMenuContent[data-side=\"top\"],\n.DropdownMenuSubContent[data-side=\"top\"] {\n  animation-name: slideDownAndFade;\n}\n\n.DropdownMenuContent[data-side=\"right\"],\n.DropdownMenuSubContent[data-side=\"right\"] {\n  animation-name: slideLeftAndFade;\n}\n\n.DropdownMenuContent[data-side=\"bottom\"],\n.DropdownMenuSubContent[data-side=\"bottom\"] {\n  animation-name: slideUpAndFade;\n}\n\n.DropdownMenuContent[data-side=\"left\"],\n.DropdownMenuSubContent[data-side=\"left\"] {\n  animation-name: slideRightAndFade;\n}\n\n.DropdownMenuItem {\n  font-size: 13px;\n  line-height: 1;\n  color: black;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  height: 25px;\n  padding: 0 5px;\n  position: relative;\n  padding-left: 20px;\n  user-select: none;\n  outline: none;\n  border: none;\n}\n\n.SelectTrigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 70px;\n  font-size: 13px;\n  line-height: 1;\n  height: 35px;\n  gap: 5px;\n  border: none;\n  background-color: #887abf;\n  width: 100px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n\n.selectEmail {\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 15px;\n  font-size: 13px;\n  line-height: 1;\n  height: 35px;\n  gap: 5px;\n  border: none;\n  background-color: #887abf;\n  width: 200px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n\noption {\n  overflow-y: scroll;\n}\n\n.SelectTrigger:hover {\n  border: none;\n  outline: none;\n}\n\n.selectEmail:hover {\n  border: none;\n  outline: none;\n}\n\n.SelectTrigger:focus {\n  /* box-shadow: 0 0 0 2px black; */\n  border: none;\n  outline: none;\n}\n\n.selectEmail:focus {\n  /* box-shadow: 0 0 0 2px black; */\n  border: none;\n  outline: none;\n}\n\n.SelectTrigger[data-placeholder] {\n  color: black;\n}\n\n.SelectIcon {\n  color: Var(--violet-11);\n}\n\n.SelectContent {\n  overflow: hidden;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow:\n    0px 10px 38px -10px rgba(22, 23, 24, 0.35),\n    0px 10px 20px -15px rgba(22, 23, 24, 0.2);\n}\n\n.SelectViewport {\n  padding: 5px;\n}\n\n.SelectItem {\n  font-size: 13px;\n  line-height: 1;\n  color: var(--violet-11);\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  height: 25px;\n  padding: 0 35px 0 25px;\n  position: relative;\n  user-select: none;\n  z-index: 10 !important;\n}\n\n.SelectItem[data-disabled] {\n  color: var(--mauve-8);\n  pointer-events: none;\n}\n\n.SelectItem[data-highlighted] {\n  outline: none;\n  background-color: var(--violet-9);\n  color: var(--violet-1);\n}\n\n.SelectLabel {\n  padding: 0 25px;\n  font-size: 12px;\n  line-height: 25px;\n  color: var(--mauve-11);\n}\n\n.SelectSeparator {\n  height: 1px;\n  background-color: var(--violet-6);\n  margin: 5px;\n}\n\n.SelectItemIndicator {\n  position: absolute;\n  left: 0;\n  width: 25px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.SelectScrollButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 25px;\n  background-color: white;\n  color: var(--violet-11);\n  cursor: default;\n}\n\n.dropDownStyle {\n  width: auto;\n}\n\n.autoSignScroll {\n  overflow-y: auto;\n}\n\n.autoSignScroll::-webkit-scrollbar {\n  display: none;\n}\n\n.validateInputText {\n  width: 76%;\n}\n\n.radioGroupInput {\n  width: 100%;\n}\n\n.radioGroup {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n@media screen and (max-width: 766px) {\n  .validateInputText {\n    width: 93%;\n  }\n\n  .dropdown-menu {\n    min-width: 0rem !important;\n  }\n\n  #navbar {\n    overflow: hidden;\n    z-index: 49;\n  }\n\n  /* Navbar links */\n  #navbar a {\n    float: left;\n    display: block;\n    color: #f2f2f2;\n    text-align: center;\n    padding: 14px;\n    text-decoration: none;\n  }\n\n  #navbar a.active {\n    background-color: #4caf50;\n    color: white;\n  }\n\n  /* Page content */\n  .content {\n    padding: 16px;\n  }\n\n  /* The sticky class is added to the navbar\n  with JS when it reaches its scroll position */\n  .stickyHead {\n    top: 50px;\n    left: 0.9rem;\n  }\n\n  .stickySignerHead {\n    position: fixed;\n  }\n\n  /* Add some top padding to the page content\n  to prevent sudden quick movement (as the\n  navigation bar gets a new position at the top of the\n  page (position:fixed and top:0) */\n  .stickyHead + .content {\n    padding-top: 60px;\n  }\n}\n\n@media screen and (max-width: 487px) and (min-width: 351px) {\n  .signatureCanvas {\n    width: 300px;\n    height: 120px;\n  }\n\n  .penContainerDefault {\n    width: 300px;\n  }\n\n  .uploadImgLogo {\n    font-size: 30px;\n  }\n\n  .signTab {\n    font-weight: 500 !important;\n    font-size: 12px !important;\n  }\n}\n\n.scroll-hide::-webkit-scrollbar {\n  display: none;\n}\n@media screen and (max-width: 350px) and (min-width: 311px) {\n  .signatureCanvas {\n    width: 280px;\n    height: 112px;\n  }\n\n  .penContainerDefault {\n    width: 280px;\n  }\n\n  .signTab {\n    font-weight: 500 !important;\n\n    font-size: 10px !important;\n  }\n\n  .uploadImgLogo {\n    font-size: 25px;\n  }\n}\n\n@media screen and (max-width: 310px) {\n  .signatureCanvas {\n    width: 230px;\n    height: 92px;\n  }\n\n  .penContainerDefault {\n    width: 230px;\n  }\n\n  .signTab {\n    font-weight: 500 !important;\n    font-size: 8px !important;\n  }\n\n  .uploadImgLogo {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
